import dayjs from "@v2/lib/dayjs";

export default function convertGregorianToShamsiDate(
  gregorianDate: string,
  shamsiFormat: string
): string {
  // Parse the input Gregorian date
  const gregorianMoment = dayjs(gregorianDate, "YYYY-MM-DD"); // Adjust the format as needed

  const shamsiDate = gregorianMoment.format(shamsiFormat);

  return shamsiDate;
}
